// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"381":"2c6112c2","453":"cd405890"}[chunkId] + ".chunk.js";
};